(function () {
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.getElementById('site-nav');
    if (!toggle || !nav || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setMainImage(img, src) {
    if (!img || !src || img.tagName !== 'IMG') return;
    img.removeAttribute('srcset');
    img.src = src;
  }

  function initBuy(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    var main = root.querySelector('.gallery-img');

    root.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMainImage(main, btn.dataset.src);
        root.querySelectorAll('.thumb').forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      });
    });

    var qty = root.querySelector('.qty input');
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.qty, 10);
        qty.value = Math.max(1, v);
      });
    });

    var select = root.querySelector('[data-variant-select]');
    var dataEl = root.querySelector('[data-variants]');
    if (select && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      select.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = v.price; });
        var compare = root.querySelector('[data-compare]');
        var badge = root.querySelector('[data-badge]');
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
        if (badge) badge.hidden = !v.compare;
        root.querySelectorAll('[data-atc]').forEach(function (btn) {
          btn.disabled = !v.available;
          var label = btn.querySelector('[data-atc-label]') || btn;
          label.textContent = v.available ? 'Add to cart' : 'Sold out';
        });
        if (v.image) setMainImage(main, v.image);
        if (location.pathname.indexOf('/products/') !== -1 && window.history.replaceState) {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(null, '', url.toString());
        }
      });
    }

    var sticky = root.querySelector('[data-sticky]');
    var form = root.querySelector('.product-form');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
  }

  function init() {
    initNav();
    document.querySelectorAll('[data-buy]').forEach(initBuy);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
